import React, { useState } from "react";
// import LoginImage from "../Images/login-image.png";
import LoginImage from "../Images/log_in.png"
import lense from "../Images/lense.png"
import Qp from "../Images/QP.png"
import frame from "../Images/Frames.png"
import EmailInputField from "../reusableField/EmailInputField";
import TextInputField from "../reusableField/TextInputField";
import { Col } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { emailRegex, passwordRegex } from "../regex/regex";
// import { BASE_URL } from "./apiConfig";
import "./LoginPage.css";
import { BASE_URL } from "./apiConfig";


const LoginPage = ({ setIsAuthenticated }) => {
    const [loginId, setLoginId] = useState("");
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState("");
    const [messageType, setMessageType] = useState("");
    const [loginLoading, setLoginLoading] = useState(false);
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [emailError, setEmailError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const navigate = useNavigate();
    // const appKey = "7cb80ffc8df6a5bf488e69f001ee0ab3";
    const validateEmail = () => {
        if (!emailRegex.test(loginId)) {
            setMessage("Email is entered wrong.");
            setMessageType("error");
            return false;
        } else {
            setMessageType("success");
            return true;
        }
    };
    const handleLogin = async (event) => {
        event.preventDefault();
        setMessage("");
        setEmailError("");
        setPasswordError("");

        let valid = true;
        if (!loginId) {
            setEmailError("Please enter your email.");
            valid = false;
        }

        if (!password) {
            setPasswordError("Please enter your password.");
            valid = false;
        }

        if (!valid || !validateEmail()) return;

        setLoginLoading(true);

        try {
            const response = await fetch(`${BASE_URL}/sign_in`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ email: loginId, password }),
            });

            const data = await response.json();

            if (response.ok) {
                localStorage.setItem("accessToken", data.access_token);
                setIsAuthenticated(true);
                navigate("/architect");
            } else {
                setMessage(data.detail || "Email or Password is incorrect.");
                setMessageType("error");
            }

        } catch (error) {
            setMessage("Unable to log in. Please try again.");
            setMessageType("error");
        } finally {
            setLoginLoading(false);
        }
    };

    return (
        <div className="background-color">
            {/* {generateShapes()} */}
            <div className="login-login-container">
                <div className="login-wrapper-container">
                    <div className="login-illustration-container">
                        <img src={LoginImage} alt="Illustration" className="login-illustration" />
                    </div>
                    <div className="login-form-container">
                        <div className="login-border">
                            {/* <img src={Qp} className="login-icon2" alt="" /> */}
                            <div className="logo-frame" style={{ display: "flex" }}>
                                <img src={frame} alt="icon2" className="login-icon2" />
                            </div>
                            <p className="login-welcome-text">Welcome</p>

                            <form className="login-login-form" autoComplete="off"
                                onSubmit={handleLogin}
                            >
                                <div className="login-form-group">
                                    <label style={{ fontSize: "15px", color: "#1C1B1F" }}>Login ID</label>
                                    <Col sm={12} xs={12} md={12} lg={12}>
                                        <EmailInputField
                                            autoComplete="off"
                                            name="Email"
                                            placeholder="Enter Login ID "
                                            type="email"
                                            value={loginId}
                                            onChange={(e) => {
                                                setLoginId(e.target.value);
                                                setEmailError("");
                                            }}
                                            feedbackMessage="Please enter Email."
                                            validationRegex={emailRegex}
                                            validationErrorMessage="Please enter a valid Email."
                                        />
                                        {emailError && <p className="login-emailandpassword-error-message">{emailError}</p>}
                                    </Col>
                                </div>
                                <div className="login-form-group">
                                    <label style={{ fontSize: "15px", color: "#1C1B1F" }}>Password</label>
                                    <Col sm={12} xs={12} md={12} lg={12}>
                                        <div className="login-password-field-container">
                                            <TextInputField
                                                autoComplete="new-password"
                                                placeholder="Enter Password"
                                                name="password"
                                                type={passwordVisible ? "text" : "password"}
                                                value={password}
                                                onChange={(e) => {
                                                    setPassword(e.target.value);
                                                    setPasswordError("");
                                                }}
                                            
                                                feedbackMessage="Please enter your password."
                                                validationRegex={passwordRegex}
                                            // validationErrorMessage="Password is required."
                                            />
                                            {passwordError && <p className="login-emailandpassword-error-message">{passwordError}</p>}
                                            {password && (
                                                <span
                                                    className="login-eye-icon"
                                                    onClick={() => setPasswordVisible(!passwordVisible)}
                                                >
                                                    {passwordVisible ? <FaEyeSlash /> : <FaEye />}
                                                </span>
                                            )}
                                        </div>
                                    </Col>
                                </div>
                                {message && <p className={`login-backend-error-message ${messageType}`}>{message}</p>}
                                <div className="login-submit-container">
                                    <button type="submit" className="login-submit-btn" disabled={loginLoading}>
                                        {loginLoading ? "Loading..." : "Submit"}
                                    </button>
                                </div>
                                <div>
                                    <p className="login-forget-password">Forget Password?&nbsp;<span onClick={() => navigate("/forgot-password")} className="login-forget-password-click-here">Click Here</span></p>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;